<template>
  <v-container fluid style="overflow: hidden !important;">
   <v-layout row wrap v-if="status_login === 'T'" class="hidden-sm-and-down">  
      <v-flex sm12 md12 lg12 xl12 >
        <div class="chatboxnonselect">

          <v-layout align-center justify-center row fill-height>
            <div style="text-align: center;">
            <img src='/static/img/pagedefault/notpermission.jpg' width="200" >
            <h2> คุณไม่สามารถเข้าถึงข้อมูลดังต่อไปนี้ได้</h2>
          </div>
          </v-layout>
          <br>
          
          <!--  -->
        </div>
      </v-flex>
      </v-layout>
      </v-container>
</template> 

<script>
import { Decode } from '@/services'

export default {
  data () {
    return {
      status_login: ''
    }
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.status_login = decoded['status_login']
  }
}
</script>
<style type="text/css" scoped>
.container{
  padding: 0px !important;
}
.fixed-content {
    min-height:100%;
    /*position:fixed;*/
    overflow-y:scroll;
    overflow-x:hidden;
} 
.content {
      padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect{
    width: 100%;
    min-width: 10vw;
    height: calc(100vh - 64px);
    background-color:white;
    overflow-y: hidden; 
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/pagedefault/NotPermission.vue